/**
 * @module roles ui
 */
import { createReducer } from '@reduxjs/toolkit';
import { userActions } from '~/behaviors/actions/user.actions';
import { uiActions } from '~/behaviors/actions/ui.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { convert } from '~/tools/convert';

const defaultState = {
  search: '',
  orderBy: 'name',
  order: 'asc',
  isLoadingRoles: false,
  isUpdatingRole: false,
  isCreatingRole: false,
};

const reset = () => defaultState;

const merge = (updates) => (state) => ({
  ...state,
  ...updates,
});

const changeUI = (state, action) => {
  const updates = action?.payload || {};
  // @ts-expect-error TS(2345): Argument of type 'string[]' is not assignable to p... Remove this comment to see the full error message
  const sanitizedAttrs = convert.pick(updates, Object.keys(defaultState));

  return {
    ...state,
    ...sanitizedAttrs,
  };
};

const rolesUI = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(uiActions.changeRolesUI, changeUI);

  builder.addCase(userActions.fetchRoles.pending, merge({ isLoadingRoles: true }));
  builder.addCase(userActions.fetchRoles.fulfilled, merge({ isLoadingRoles: false }));
  builder.addCase(userActions.fetchRoles.rejected, merge({ isLoadingRoles: false }));

  builder.addCase(userActions.updateRole.pending, merge({ isUpdatingRole: true }));
  builder.addCase(userActions.updateRole.fulfilled, merge({ isUpdatingRole: false }));
  builder.addCase(userActions.updateRole.rejected, merge({ isUpdatingRole: false }));

  builder.addCase(userActions.createRole.pending, merge({ isCreatingRole: true }));
  builder.addCase(userActions.createRole.fulfilled, merge({ isCreatingRole: false }));
  builder.addCase(userActions.createRole.rejected, merge({ isCreatingRole: false }));
});

export default rolesUI;
